export default {
  'connections.title': 'Conexiones',
  'connectionGroup.title': 'Grupos de Conexiones',

  'connections.tabs.general': 'Generales',
  'connections.tabs.configurations': 'Configuraciones',

  'connections.type.azuregraph': 'Azure Graph',
  'connections.type.openai': 'OpenAI',
  'connections.type.google': 'Google',
  'connections.type.api': 'Api',
  'connections.type.database': 'Database',
  'connections.type.azuregraphsharepoint': 'Azure Graph SharePoint',
  'connections.type.ftp': 'Ftp',
  'connections.type.linkedin': 'LinkedIn',
  'connections.type.whatsappbusiness': 'WhatsApp Business',
  'connections.type.sendgrid': 'SendGrid',
  'connections.type.modelcontextprotocol': 'Protocolo de Contexto de Modelo',
  'connections.type.metapages': 'Meta Pages',

  'connections.azuregraph.userName': 'Usuario',
  'connections.azuregraph.password': 'Contraseña',
  'connections.azuregraph.clientId': 'Id del Cliente',
  'connections.azuregraph.userId': 'ID de Usuario',
  'connections.azuregraph.userDisplayName': 'Nombre para Mostrar',
  'connections.azuregraph.tokenType': 'Tipo de Token',
  'connections.azuregraph.accessToken': 'Token de Acceso',
  'connections.azuregraph.accessTokenExpiration': 'Expiración del Token de Acceso',
  'connections.azuregraph.refreshToken': 'Token de Renovación',
  'connections.azuregraph.scopes': 'Permisos',

  'connections.openai.apiKey': 'Clave Api',
  'connections.openai.organizationKey': 'Clave de Organización',

  'connections.google.type': 'Tipo',
  'connections.google.projectId': 'ID del Proyecto',
  'connections.google.privateKeyId': 'ID de la Clave Privada',
  'connections.google.privateKey': 'Clave Privada',
  'connections.google.clientEmail': 'Correo del Cliente',
  'connections.google.clientId': 'Id del Cliente',
  'connections.google.authUri': 'URI de Autenticación',
  'connections.google.tokenUri': 'URI del Token',
  'connections.google.authProviderX509CertUrl': 'URL del Certificado X509 del Proveedor',
  'connections.google.clientX509CertUrl': 'URL del Certificado X509 del Cliente',
  'connections.google.universeDomain': 'Dominio Universal',
  'connections.google.scopes': 'Permisos',

  'connections.api.method': 'Método',
  'connections.api.method.post': 'Post',
  'connections.api.method.get': 'Get',
  'connections.api.method.put': 'Put',
  'connections.api.method.delete': 'Delete',
  'connections.api.method.patch': 'Patch',
  'connections.api.authorizationType': 'Tipo de Autorización',
  'connections.api.authorizationType.noauth': 'Sin Autenticación',
  'connections.api.authorizationType.apikeyinheader': 'API Key - En Cabecera',
  'connections.api.authorizationType.apikeyinqueryparameters': 'API Key - En Url',
  'connections.api.authorizationType.bearertoken': 'Token Bearer',
  'connections.api.authorizationType.basicauth': 'Autenticación Básica',
  'connections.api.authorizationType.oauth': 'OAuth',
  'connections.api.authorizationType.automyonbehalfjwt': 'JWT firmado por AUTOMY',
  'connections.api.url': 'URL',
  'connections.api.keyName': 'Nombre de Clave',
  'connections.api.keyValue': 'Valor de Clave',
  'connections.api.token': 'Token',
  'connections.api.username': 'Usuario',
  'connections.api.password': 'Contraseña',
  'connections.api.oAuthConnection': 'Conexión OAuth',
  'connections.api.oAuthConnectionId': 'ID de la Conexión OAuth',
  'connections.api.oAuthTokenResponsePropertyPosition': 'Posición del token en la respuesta',
  'connections.api.oAuthTokenResponsePropertyName':
    'Nombre de la propiedad del token en la respuesta',
  'connections.api.oAuthJsonBody': 'Cuerpo JSON',
  'connections.api.oAuthTokenSendPropertyPosition': 'Posición del token en el envío',
  'connections.api.oAuthTokenSendPropertyName': 'Nombre de la propiedad del token en el envío',
  'connections.api.subjectClaim': 'Identificador del usuario',
  'connections.api.audienceClaim': 'Destinatario del servicio',
  'connections.api.additionalClaims': 'Datos adicionales',
  'connections.api.additionalClaims.name': 'Nombre',
  'connections.api.additionalClaims.value': 'Valor',

  'connections.api.codeField': 'Nombre de Campo Código',
  'connections.api.showField': 'Nombre de Campo a Mostrar',
  'connections.api.resultContainerPropertyName': 'Nombre de Campo con los Resultados',
  'connections.api.displayTextPropertyName': 'Nombre del Campo para Búsqueda',
  'connections.api.codePropertyName': 'Nombre de Campo Código',
  'connections.api.isSharedForAllInCompany': 'Compartida con toda la empresa',
  'connections.apiHeader': 'Api Header',
  'connections.apiHeader.key-exits': 'LLave Existe',
  'connections.api.webApiConnectionGroup': 'Grupo',

  'connections.api.position.header': 'Cabecera',
  'connections.api.position.url': 'Url',
  'connections.api.position.formdata': 'Formulario',
  'connections.api.position.bodyjson': 'Cuerpo(JSON)',
  'connections.api.position.xwwwformurlencoded': 'Formulario Url Codificada',
  'connections.api.position.authorization': 'Autorización',
  'connections.api.position.bodytext': 'Cuerpo(Texto)',
  'connections.api.position.formfiledata': 'Formulario / Fichero',
  'connections.api.parameters': 'Parámetros',
  'connections.api.confidential': 'Confidencial',
  'connections.api.notConfidential': 'No Confidencial',

  'connections.api.title': 'Configurar Conexiones APIs',
  'connections.api.address': 'Dirección URL',

  'connections.database.databaseType': 'Tipo',
  'connections.database.database': 'Nombre',
  'connections.database.host': 'Host',
  'connections.database.port': 'Puerto',
  'connections.database.username': 'Usuario',
  'connections.database.password': 'Contraseña',
  'connections.database.query': 'Consulta',

  'connections.database.databaseType.sqlserver': 'SQL Server',
  'connections.database.databaseType.access': 'Access',
  'connections.database.databaseType.mysql': 'MySQL',

  'connections.azuregraphsharepoint.sharePointCompanyUrl': 'Url de la empresa',
  'connections.azuregraphsharepoint.userName': 'Nombre de usuario',
  'connections.azuregraphsharepoint.password': 'Contraseña',
  'connections.azuregraphsharepoint.clientId': 'Id del cliente',
  'connections.azuregraphsharepoint.clientSecret': 'Clave del cliente',
  'connections.azuregraphsharepoint.authorityUrl': 'Url de autorización',

  'connections.ftp.transferType': 'Tipo de Transferencia',
  'connections.ftp.host': 'Host',
  'connections.ftp.userName': 'Nombre de Usuario',
  'connections.ftp.authenticationMode': 'Modo de Autenticación',
  'connections.ftp.password': 'Contraseña',
  'connections.ftp.privateKeyFile': 'Archivo de Clave Privada',
  'connections.ftp.authenticationMode.password': 'Contraseña',
  'connections.ftp.authenticationMode.privatekeyfile': 'Archivo de Clave Privada',

  'connections.linkedin.clientId': 'Id del Cliente',
  'connections.linkedin.clientSecret': 'Clave del Cliente',
  'connections.linkedin.scopes': 'Permisos',

  'connections.whatsappbusiness.phoneNumberId': 'ID del Número de Teléfono',
  'connections.whatsappbusiness.displayPhoneNumber': 'Número de Teléfono de Visualización',
  'connections.whatsappbusiness.whatsAppBusinessAccountId': 'ID de la Cuenta de WhatsApp Business',
  'connections.whatsappbusiness.appId': 'ID de la Aplicación',
  'connections.whatsappbusiness.webhookVerifyToken': 'Token de Verificación del Webhook',
  'connections.whatsappbusiness.accessToken': 'Token de Acceso',

  'connections.sendgrid.apiKey': 'Clave Api',
  'connections.sendgrid.emails': 'Correos',
  'connections.sendgrid.emails.name': 'Nombre',
  'connections.sendgrid.emails.email': 'Correo',
  'connections.sendgrid.webhookEventVerificationKey':
    'Clave de Verificación de Eventos del Webhook',
  'connections.sendgrid.webhookInboundParserEventVerificationKey':
    'Clave de Verificación de Eventos del Analizador Entrante de Webhook',
  'connections.sendgrid.emailValidation': 'Validación de Correos',

  'connections.modelcontextprotocol.connectionType': 'Tipo de Conexión',
  'connections.modelcontextprotocol.connectionType.remote': 'Remoto',
  'connections.modelcontextprotocol.connectionType.localprocess': 'Proceso Local',
  'connections.modelcontextprotocol.endpoint': 'Endpoint',
  'connections.modelcontextprotocol.command': 'Comando',
  'connections.modelcontextprotocol.arguments': 'Argumentos',
  'connections.modelcontextprotocol.authorizationType': 'Tipo de Autorización',
  'connections.modelcontextprotocol.authorizationType.noauth': 'Sin Autenticación',
  'connections.modelcontextprotocol.authorizationType.automyonbehalfjwt': 'Automy On Behalf Jwt',
  'connections.modelcontextprotocol.additionalAgentInstructions':
    'Instrucciones Adicionales del Agente',
  'connections.modelcontextprotocol.additionalAgentInstructions.edit':
    'Editar Instrucciones Adicionales del Agente',
  'connections.modelcontextprotocol.additionalAgentInstructions.placeholder':
    'Ingrese instrucciones adicionales para el agente...',
  'connections.modelcontextprotocol.additionalAgentVectors': 'Vectores Adicionales del Agente',

  'connections.metapages.businessAccountId': 'ID de Cuenta de Negocio',
  'connections.metapages.appId': 'ID de Aplicación',
  'connections.metapages.appSecret': 'Secreto de Aplicación',
  'connections.metapages.accessToken': 'Token de Acceso',
  'connections.metapages.webhookVerifyToken': 'Token de Verificación del Webhook',

  'connections.databases.title': 'Gestionar Conexiones Bases de Datos',

  'connections.text.ownerUser': 'Propietario',
  'connections.text.validated': 'Validada',
  'connections.text.permissions': 'Permisos',
  'connections.text.server': 'Servidor',
  'connections.text.validateAfterSave': 'Validar',
  'connections.text.collaborators': 'Colaboradores',
  'connections.text.groups': 'Grupos de Conexiones',

  'connections.callback.redirecting': 'Redirigiendo a la lista de conexiones...',
};
